import { notificationSchema } from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import i18n from "i18next";
import { z } from "zod";

const LANG_BASE = "vessel-call.port-services.fields";

const internalNotesSchema = z.object({
  files: z.any().optional(),
  internalNotes: z
    .string()
    .max(
      1000,
      i18n.t("form-validation.max-length", {
        label: i18n.t(`${LANG_BASE}.internal-notes`),
        max: 1000,
      }),
    )
    .optional(),
});

const externalNotesSchema = z.object({
  files: z.any().optional(),
  externalNotes: z
    .string()
    .max(
      1000,
      i18n.t("form-validation.max-length", {
        label: i18n.t(`${LANG_BASE}.external-notes`),
        required_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.external-notes`),
        }),
        max: 1000,
      }),
    )
    .optional(),
});

export const approveByMDSlopsDisposalSchema = () =>
  internalNotesSchema.merge(externalNotesSchema).merge(notificationSchema);

export type ApproveByMDSlopsDisposalSchema = z.infer<
  ReturnType<typeof approveByMDSlopsDisposalSchema>
>;
